import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import {
  getClassroomsRequest,
  getStudentsReportRequest,
} from 'src/services/api.service'
import { useNotification } from 'src/contexts/notification.context'
import { useAuth } from 'src/contexts/auth.context'
import { SubjectSelect } from 'src/components/common'
import { Select } from 'src/components/select'
import { routes } from 'src/navigation/routes'

export const TeacherDashboard = () => {
  const { user } = useAuth()
  const { isLoading, wrapCallback } = useNotification()
  const [isFirstLoad, setIsFirstLoad] = useState(true)
  const [classrooms, setClassrooms] = useState([])
  const [report, setReport] = useState({ tasks: [], students: [], scores: [] })
  const [filter, setFilter] = useState({
    subject_id: null,
    classroom_id: null,
    period: 'month',
  })

  // useEffect(() => {
  //   wrapCallback(async () => {
  //     await Promise.all([fetchClassrooms(), fetchReport()]).then(values => {
  //       // console.log(values)
  //       setIsFirstLoad(false)
  //     });
  //   });
  // }, []);

  useEffect(() => {
    if (isFirstLoad) return

    wrapCallback(async () => {
      // await fetchReport();
    })
  }, [filter.period, filter.classroom_id, filter.subject_id])

  const fetchClassrooms = async () => {
    const result = await getClassroomsRequest()
    setClassrooms(result.data.items)
    return true
  }

  const fetchReport = async () => {
    const result = await getStudentsReportRequest(filter)
    setReport(result.data)
    return true
  }

  const calcAverage = (pItems, id) => {
    const items = pItems.filter((x) => x)

    if (items.length <= 0)
      return <div key={id} className="report__line__col inactive" />

    return (
      <div key={id} className="report__line__col">
        {Math.round(items.reduce((val, acc) => acc + val, 0) / items.length) ||
          0}
      </div>
    )
  }

  const calcAverageTask = (scores, taskId) => {
    const items = Object.values(scores)
      .map((x) => x[taskId])
      .filter((x) => x)

    if (items.length <= 0)
      return <div key={taskId} className="report__line__col inactive" />

    console.log('items', items)

    return (
      <div key={taskId} className="report__line__col">
        {Math.round(items.reduce((acc, val) => acc + val, 0) / items.length)}
      </div>
    )
  }

  return (
    <>
      <h2 className="sectionHb-title">Dashboard</h2>

      {Object.values(report.scores).length === 0 ? (
        <div className="sectionHb-block dashboardHb">
          <div className="sectionHb-block__wrap">
            <h2 className="sectionHb-title">
              Welcome,{' '}
              <span>
                {user.first_name} {user.last_name}
              </span>
            </h2>
            <div className="dashboardHb-img">
              <img src="/account/img/dashboard/img-2.svg" alt="" />
            </div>
            {/* <p>Welcome to your <b>Practithink</b> account! <br/>Create tests, sell printouts. Educate your children and help others.</p> */}
            <div className="practithinkHb">
              <span className="practithinkHb-title">
                Your Practithink starts here
              </span>
              <div className="row">
                <div className="practithinkHb-col col-lg-3 col-md-4 col-sm-6">
                  <Link
                    to={routes.classrooms.index}
                    className="practithinkHb-wrap"
                  >
                    <div className="practithinkHb-ico">
                      <img src="/account/img/dashboard/ico-5.svg" alt="" />
                    </div>
                    <span className="practithinkHb-subtitle">
                      Call students
                    </span>
                  </Link>
                </div>
                <div className="practithinkHb-col col-lg-3 col-md-4 col-sm-6">
                  <Link
                    to={routes.practices.options}
                    className="practithinkHb-wrap"
                  >
                    <div className="practithinkHb-ico">
                      <img src="/account/img/dashboard/ico-6.svg" alt="" />
                    </div>
                    <span className="practithinkHb-subtitle">Create task</span>
                  </Link>
                </div>
                <div className="practithinkHb-col col-lg-3 col-md-4 col-sm-6">
                  <Link
                    to={routes.profile.index}
                    className="practithinkHb-wrap"
                  >
                    <div className="practithinkHb-ico">
                      <img src="/account/img/dashboard/ico-7.svg" alt="" />
                    </div>
                    <span className="practithinkHb-subtitle">
                      Manage profile
                    </span>
                  </Link>
                </div>
                {/* <div className="practithinkHb-col col-lg-3 col-md-4 col-sm-6">
                    <Link to="/awards" className="practithinkHb-wrap">
                      <div className="practithinkHb-ico"><img src="/account/img/dashboard/ico-8.svg" alt="" /></div>
                      <span className="practithinkHb-subtitle">Set goals and rewards</span>
                    </Link>
                  </div> */}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="report">
          <div className="report__inner">
            <div className="reportCard-table">
              <div className="reportCard-table__row reportCard-table__top">
                <div
                  className="reportCard-table__col reportCard-table__col-1"
                  style={{ display: 'block' }}
                >
                  <div className="row">
                    <div className="col-4 mb-15">
                      <Select
                        black
                        placeholder="Period"
                        icon="/account/images/dest/icons/timetable--small.svg"
                        value={filter.period}
                        onChange={(item) => {
                          setFilter({ ...filter, period: item?.value })
                        }}
                        options={[
                          { value: 'week', label: 'This week' },
                          { value: 'month', label: 'This month' },
                        ]}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-4 mb-15">
                      <SubjectSelect
                        value={filter.subject_id}
                        onChange={(item) => {
                          setFilter({ ...filter, subject_id: item?.value })
                        }}
                      />
                    </div>
                    <div className="col-4 mb-15">
                      <Select
                        value={filter.classroom_id}
                        onChange={(item) => {
                          setFilter({ ...filter, classroom_id: item?.value })
                        }}
                        placeholder="Classrooms"
                        options={classrooms.map((x) => ({
                          value: x.id,
                          label: x.name,
                        }))}
                      />
                    </div>
                  </div>

                  <div className="reportCard-table__center">
                    <b>Math</b>
                  </div>
                </div>

                {report.tasks.map((x) => (
                  <div
                    key={x.title}
                    className="reportCard-table__col reportCard-table__col-2"
                  >
                    <span>{x.title}</span>
                  </div>
                ))}

                {Object.values(report.scores).length > 0 && (
                  <div
                    key="average"
                    className="reportCard-table__col reportCard-table__col-2"
                  >
                    <span>Average</span>
                  </div>
                )}
                <div className="reportCard-table__date">01.01-30.06</div>
              </div>

              <div className="reportCard-table__row">
                <div className="reportCard-table__col reportCard-table__col-1">
                  <div className="reportCard-table__center">
                    <b>Math</b>
                  </div>
                </div>

                {Object.values(report.scores).length > 0 &&
                  report.tasks.map((x) => (
                    <div
                      key={x.id}
                      className="reportCard-table__col reportCard-table__col-2"
                    >
                      {calcAverageTask(report.scores, x.id)}
                    </div>
                  ))}
                <div
                  key="av-av"
                  className="reportCard-table__col reportCard-table__col-2"
                >
                  &nbsp;
                </div>
              </div>

              {report.students.map((x) => (
                <div key={x.id} className="reportCard-table__row">
                  <div className="reportCard-table__col reportCard-table__col-1">
                    <div className="input-block">
                      <label htmlFor="kj-1">
                        {x.first_name} {x.last_name}
                      </label>
                    </div>
                  </div>

                  {Object.values(report.scores).length > 0 &&
                    Object.keys(report.scores[x.id]).map((k) => (
                      <div
                        key={k}
                        className="reportCard-table__col reportCard-table__col-2"
                      >
                        {report.scores[x.id][k] === null
                          ? ''
                          : report.scores[x.id][k]}
                      </div>
                    ))}

                  <div
                    key="average-"
                    className="reportCard-table__col reportCard-table__col-3"
                  >
                    {calcAverage(Object.values(report.scores[x.id], x.id))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  )
}
